import React, { useState } from 'react';
import DesignThinkingWhy from './DesignThinkingWhy';
import DesignThinkingTools from './DesignThinkingTools';

type TabType = 'why' | 'tools';

const DesignThinkingMainTabs: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('tools');

  return (
    <div className="dd-main-tabs-section" style={{ background: '#fff !important' }}>
      <div className="container mb-4">
        <div className="d-flex justify-content-center align-items-center gap-2 dd-main-tabs" style={{ borderBottom: '2.5px solid #e5eaf1' }}>
          <button
            className={`dd-main-tab ${activeTab === 'why' ? 'active' : ''}`}
            data-tab="why"
            type="button"
            onClick={() => setActiveTab('why')}
          >
            Why
          </button>
          <button
            className={`dd-main-tab ${activeTab === 'tools' ? 'active' : ''}`}
            data-tab="tools"
            type="button"
            onClick={() => setActiveTab('tools')}
          >
            Tools
          </button>
        </div>
        <div className="dd-main-tab-content mt-4">
          <DesignThinkingWhy isActive={activeTab === 'why'} />
          <DesignThinkingTools isActive={activeTab === 'tools'} />
        </div>
      </div>
    </div>
  );
};

export default DesignThinkingMainTabs;

